import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Header from "../Header/Header";
import Connect from "../../store/config/connect";
import "./PreCadastro.css";

const estadosBrasil = [
    { nome: "Acre", sigla: "AC" },
    { nome: "Alagoas", sigla: "AL" },
    { nome: "Amapá", sigla: "AP" },
    { nome: "Amazonas", sigla: "AM" },
    { nome: "Bahia", sigla: "BA" },
    { nome: "Ceará", sigla: "CE" },
    { nome: "Distrito Federal", sigla: "DF" },
    { nome: "Espírito Santo", sigla: "ES" },
    { nome: "Goiás", sigla: "GO" },
    { nome: "Maranhão", sigla: "MA" },
    { nome: "Mato Grosso", sigla: "MT" },
    { nome: "Mato Grosso do Sul", sigla: "MS" },
    { nome: "Minas Gerais", sigla: "MG" },
    { nome: "Pará", sigla: "PA" },
    { nome: "Paraíba", sigla: "PB" },
    { nome: "Paraná", sigla: "PR" },
    { nome: "Pernambuco", sigla: "PE" },
    { nome: "Piauí", sigla: "PI" },
    { nome: "Rio de Janeiro", sigla: "RJ" },
    { nome: "Rio Grande do Norte", sigla: "RN" },
    { nome: "Rio Grande do Sul", sigla: "RS" },
    { nome: "Rondônia", sigla: "RO" },
    { nome: "Roraima", sigla: "RR" },
    { nome: "Santa Catarina", sigla: "SC" },
    { nome: "São Paulo", sigla: "SP" },
    { nome: "Sergipe", sigla: "SE" },
    { nome: "Tocantins", sigla: "TO" }
];

const PreCadastro = (props) => {
  const history = useHistory();
  const [selectedState, setSelectedState] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredStates, setFilteredStates] = useState([]);
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (inputValue.trim() === "") {
      setFilteredStates(estadosBrasil);
    } else {
      const filtered = estadosBrasil.filter(estado =>
        estado.nome.toLowerCase().includes(inputValue.toLowerCase()) ||
        estado.sigla.toLowerCase().includes(inputValue.toLowerCase())
      );
      setFilteredStates(filtered);
    }
  }, [inputValue]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
          inputRef.current && !inputRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setSelectedState("");
    setShowDropdown(true);
  };

  const handleStateSelect = (estado) => {
    setSelectedState(estado);
    setInputValue(estado.nome);
    setShowDropdown(false);
    
    // Armazenar o estado selecionado no sessionStorage para uso no cadastro
    sessionStorage.setItem('preCadastroEstado', JSON.stringify(estado));
    
    setTimeout(() => {
      if (estado.sigla === "RJ") {
        history.push("/pre-cadastro/step2");
      } else {
        history.push("/cadastrar");
      }
    }, 300);
  };

  const handleInputFocus = () => {
    setShowDropdown(true);
  };


  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (filteredStates.length > 0 && !selectedState) {
        handleStateSelect(filteredStates[0]);
      }
    } else if (e.key === "Escape") {
      setShowDropdown(false);
    }
  };

  return (
    <div className="pre-cadastro-container">
      <Header />
      <div className="pre-cadastro-content">
        <div className="pre-cadastro-card">
          <div className="pre-cadastro-accent-bar"></div>
          <div className="pre-cadastro-form">
            <h2>Por favor, <br/> selecione seu Estado.</h2>
            <div className="input-container">
              <input
                ref={inputRef}
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                onFocus={handleInputFocus}
                onKeyDown={handleKeyDown}
                placeholder="Estado"
                className="state-input"
                autoComplete="off"
              />
              <div className="dropdown-arrow">
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                  <path d="M1 1.5L6 6.5L11 1.5" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              
              {showDropdown && (
                <div ref={dropdownRef} className="dropdown-list">
                  {filteredStates.length > 0 ? (
                    filteredStates.map((estado, index) => (
                      <div
                        key={index}
                        className="dropdown-item"
                        onClick={() => handleStateSelect(estado)}
                      >
                        {estado.nome}
                      </div>
                    ))
                  ) : (
                    <div className="dropdown-item no-results">
                      Nenhum estado encontrado
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ auth, helper }) => {
  return {
    auth,
    helper,
  };
};

export default Connect(mapStateToProps)(PreCadastro);
